@if (createSite) {
    <form class="site-container">
        <h3>{{ 'site.name' | translate }}</h3>
        <section>
            <custom-input inputType="radio" [(value)]="selectedType">
                @for (type of siteTypes; track type) {
                    <radio-button [value]="type" [label]="'site.type.' + siteTypeEnum[type] | translate" />
                }
            </custom-input>
            <custom-input prefix="www."
                          [inputType]="inputTypeEnum.Text"
                          [(value)]="pointerName"
                          [validation]="validationType.Domain"
                          [required]="true"
                          [placeholder]="'site.name-placeholder' | translate"></custom-input>
            <select-website-product-plan [(productPlanId)]="productPlanId" [companyId]="companyId" />
        </section>
        <section>
            <button #saveButton confirm (click)="save()">{{ 'site.create' | translate }}</button>
        </section>
    </form>
}
@else {
    <section>
        <button [ignoreValidation]="true" [loader]="false" (click)="createSite = true">{{ 'site.create-new' | translate }}</button>
    </section>
}
